<template>
  <section class="layout" :style="{minHeight: overHeight + 'px'}">
    <div class="layout-top">
      <mul-head class="layout-header">
        <template v-slot:logo> 
          <div class="layout-header-logo">
            <router-link to="/">
              <img src='../assets/zmlogo.png' />
            </router-link>
          </div>
        </template>
        <template v-slot:nav>
          <mul-nav class="layout-header-nav" :navList="navList"/>
        </template>
      </mul-head>
    </div>
    <div class="layout-view">
      <slot name="view"></slot>
    </div>
    <div class="layout-bot">
      <mul-foot class="layout-footer">
        <div slot="ba-copy" class="layout-footer-copy">
          地址：上海市闵行区田林路1036号科技绿洲三期16号楼4楼&nbsp;&nbsp;联系电话：021-64480221&nbsp;&nbsp;版权所有&copy;上海卓盟信息科技有限公司&nbsp;&copy;<a href="http://www.beian.miit.gov.cn" target="_blank">沪ICP备13023469号-7</a>
        </div>
      </mul-foot>
    </div>
  </section>
</template>

<script>
import mulHead from '@/components/Head.vue'
import mulNav from '@/components/Nav.vue'
import mulFoot from '@/components/Foot.vue'
export default {
  components: {
    mulHead,
    mulNav,
    mulFoot
  },
  props: {},
  data () {
    return {
      overHeight: window.innerHeight,
      navList: [{
        path: '/',
        name: 'home',
        text: '首页'
      },  {
        path: '/reports',
        name: 'reports',
        text: '数据报告'
      }, {
        path: '/contact',
        name: 'contact',
        text: '联系我们'
      }, {
        path: '/login',
        name: 'login',
        text: '登录'
      }]
    }
  },
  watch: {},
  computed: {},
  methods: {},
  created () {},
  mounted () {}
}
</script>
<style scoped>
.layout {
  position: relative;
}
.layout-top {
  width: 100%;
  background-color: #222;
}
.layout-header {
  height: 90px;
  padding: 15px 88px;
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.layout-header-logo {
  float: left;
  line-height: 60px;
}
.layout-header-logo img{
  width: 170px;
  height: 60px;
  float: left;
}
.layout-header-logo span {
  float: left;
  color: #fff;
  font-size: 24px;
  margin-left: 20px;
  font-weight: 500;
}
.layout-header-nav {
  float: right;
}
.layout-bot {
  width: 100%;
  position: absolute;
  bottom: 0;
  height: 90px;
}
.layout-footer-copy {
  width: 100%;
  height: 90px;
  line-height: 90px;  
  position: absolute;
  background-color: #e8e8e8;
  color: #666;
  text-align: center;
  font-size: 14px;
}
.layout-footer-copy a {
  color: inherit;
}
.layout-view {
  margin: 0 auto;
}
</style>